import { Component, Input, CUSTOM_ELEMENTS_SCHEMA, OnInit, signal } from '@angular/core';

import { Router, RouterModule } from '@angular/router';
import '@maersk-global/mds-components-core/mc-tag';
import { WorkOrderHeaderComponent } from '../../components/view-work-order/work-order-header/work-order-header.component';
import { WorkOrderService } from '../../services/work-order.service';
import { Equipment } from '../../models/equipment.model';
import { CreateWorkOrerContainerDetailsComponent } from '../../components/create-work-order/container-details/cwo-container-details.component';
import { AemsFile } from '../../models/aems-file.model';
import { BlobService } from '../../services/blob.service';
import { FileUploadComponent } from '../../shared-components/aems-file-upload/file-upload.component';
import { ListRepairLineItemsComponent } from '../../components/view-work-order/list-repair-line-items/list-repair-line-items.component';
import { EMPTY, ReplaySubject, catchError, firstValueFrom, forkJoin, takeUntil, timer } from 'rxjs';
import { CreateWorkOrderRemarksComponent } from '../../components/create-work-order/remarks/cwo-remarks.component';
import { ToastrService } from '../../services/toastr-service';
import { MaintenanceOrderResponse } from '../../models/maintenance-order-response.model';
import { TotalCost } from '../../models/total-cost-model';
import { CreateWorkOrderTotalCostComponent } from '../../components/create-work-order/total-cost/cwo-total-cost/cwo-total-cost.component';
import { AttachedImage } from '../../models/maintenance-order-attached-image';
import { SharedDataService } from '../../services/shared-data.service';
import { utils } from '../../helper/utils';
import { APICallStatus } from '../../models/api-call-status.mode';
import { LoaderComponent } from '../../shared-components/loader/loader.component';
import { AuditLogComponent } from '../../components/view-work-order/audit-log/audit-log.component';
import { AuthPolicies } from '../../auth/auth-policies';
import { MaintenanceOrderStatusCode } from '../../models/maintenance-order-status.model';
import { clone } from 'lodash-es';
import { MaintenanceOrderPartSerialNumberUpdateRequest } from '../../models/maintenance-order-part-serial-number-update-request.model';
import { MaintenanceOrderPartSerialNumbers } from '../../models/maintenance-order-part-serial-numbers-entry.model';
import { MaintenanceOrderChangeResult } from '../../models/maintenance-order-change-result.model';
import { ApplicationtTextService } from '../../services/application-text.service';
import { CreateWorkOrderAlarmDetailsComponent } from '../../components/create-work-order/cwo-alarm-details/cwo-alarm-details.component';
import { MasterDataService } from '../../services/master-data.service';
import { Mode } from '../../models/mode.model';
import { AuditLog } from '../../models/audit-log.model';
import { AemsAuditLogComponent } from '../../shared-components/aems-audit-log/aems-audit-log.component';
import { PrintDialogComponent } from '../../components/view-work-order/print-dialog/print-dialog.component';
import { PrintWorkOrderComponent } from '../../components/view-work-order/print-work-order/print-work-order.component';
@Component({
  selector: 'app-view-work-order',
  imports: [
    WorkOrderHeaderComponent,
    RouterModule,
    CreateWorkOrerContainerDetailsComponent,
    FileUploadComponent,
    ListRepairLineItemsComponent,
    CreateWorkOrderRemarksComponent,
    CreateWorkOrderTotalCostComponent,
    LoaderComponent,
    AuditLogComponent,
    CreateWorkOrderAlarmDetailsComponent,
    AemsAuditLogComponent,
    PrintDialogComponent,
    PrintWorkOrderComponent,
  ],
  templateUrl: './view-work-order.component.html',
  styleUrl: './view-work-order.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ViewWorkOrderComponent implements OnInit {
  @Input() id!: string;
  openDeleteWorkOrderConfirmation: boolean = false;
  equipment: Equipment | null = null;
  gensetHours: number | null = null;
  workOrder: MaintenanceOrderResponse | null = null;
  totalCost!: TotalCost;
  blobFilesResolved = signal(false);
  workOrderStatus = signal('');
  viewDataApiCalls: APICallStatus = 'NOT_STARTED';
  deleteApiCallStatus: APICallStatus = 'NOT_STARTED';
  markAsCompleteAPICallStatus: APICallStatus = 'NOT_STARTED';
  markAsTtlApiCallStatus: APICallStatus = 'NOT_STARTED';
  auditlogApiCallStatus: APICallStatus = 'NOT_STARTED';

  isSystemLog: boolean = true;
  auditlogNewApiCallStatus: APICallStatus = 'NOT_STARTED';
  currentPage: number = 1;
  pageLimit: number = 100;
  newAuditLogData: AuditLog[] = [];

  openPrintDialog: boolean = false;
  includeRemarksInPrint: boolean = true;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  openAuditLog: boolean = false;
  openNewAuditLog: boolean = false;
  openMarkAsTTLConfirmation: boolean = false;
  totalManHoursSummary: number = 0;
  rejectAsTtlApiCallStatus: APICallStatus = 'NOT_STARTED';
  auditLog: MaintenanceOrderChangeResult = {} as MaintenanceOrderChangeResult;
  allowedStatusToDelete: MaintenanceOrderStatusCode[] = [
    MaintenanceOrderStatusCode.Draft,
    MaintenanceOrderStatusCode.Rejected,
    MaintenanceOrderStatusCode.PendingApproval,
    MaintenanceOrderStatusCode.PendingManagerApproval,
    MaintenanceOrderStatusCode.PendingSpecialistApproval,
    MaintenanceOrderStatusCode.Approved,
  ];
  suspendForTTLCheckStatus: MaintenanceOrderStatusCode = MaintenanceOrderStatusCode.SuspendForTTLCheck;
  mode!: Mode;

  constructor(
    private workOrderService: WorkOrderService,
    private blobService: BlobService,
    private toastrService: ToastrService,
    private sharedDataService: SharedDataService,
    public authPolicy: AuthPolicies,
    private router: Router,
    private appTextService: ApplicationtTextService,
    private masterDataService: MasterDataService,
  ) {}
  async ngOnInit() {
    this.viewDataApiCalls = 'IN_PROGRESS';
    this.workOrder = await firstValueFrom(
      this.workOrderService.getWorkOrderById(this.id).pipe(
        takeUntil(this.destroyed$),
        catchError((err) => {
          throw err;
        }),
      ),
    );
    if (this.workOrder) {
      this.workOrderStatus.set(utils.getMaintenanceOrderStatusText(this.workOrder.maintenanceOrderStatusCode).description);
      this.workOrder.maintenanceOrderManHours.forEach((item) => {
        if (item.manHours && item.manHoursType != 'TOTALPREPARATION') {
          this.totalManHoursSummary += item.manHours;
        }
      });
      this.totalManHoursSummary = utils.formatNumberToTwoDigitDecimal(this.totalManHoursSummary);
      this.workOrder.blobResolvedFiles = await this.getBlobUrl(this.workOrder.maintenanceShopCode, this.workOrder.attachedImages);
      for (const item of this.workOrder.maintenanceOrderLines) {
        item.blobResolvedFiles = await this.getBlobUrl(this.workOrder?.maintenanceShopCode, item.attachedImages);
        item.maintenanceOrderParts?.forEach((partItem) => {
          partItem.unitPrice = utils.formatNumberToTwoDigitDecimal(partItem.unitPrice);
        });
      }
      this.blobFilesResolved.set(true);
      this.validateEquipmentNumber();
    } else {
      this.toastrService.showToastr(this.appTextService.workOrderDoesNotExist, 'warning');
    }

    let equipmentNumber = this.workOrder?.equipmentNumber ?? '';
    this.workOrderService
      .getEquipmentDetails(this.id)
      .pipe(
        takeUntil(this.destroyed$),
        catchError((err) => {
          this.toastrService.showToastr(this.appTextService.unableToGetEquipmentDetails, 'error');
          throw err;
        }),
      )
      .subscribe((response) => {
        this.equipment = clone(response);
        if (this.equipment) {
          this.equipment.equipmentNumber = equipmentNumber;
        }
        if (response?.equipmentAlarms && response?.equipmentAlarms.length > 0 && this.equipment) {
          this.equipment.alarms = response?.equipmentAlarms;
        }
        this.getGensetHours();
      });

    this.workOrderService
      .getTotalCost(this.id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response) => {
        this.totalCost = response;
      });
    this.mode = await firstValueFrom(this.masterDataService.getRepairMode(this.workOrder.maintenanceRepairModeCode));

    this.viewDataApiCalls = 'COMPLETED_SUCCESFULLY';
  }
  private validateEquipmentNumber(): void {
    let equipmentNumber: string | undefined = this.workOrder?.equipmentNumber;
    let maintenanceRepairModeCode: string | undefined = this.workOrder?.maintenanceRepairModeCode;
    this.workOrderService.validateEquipmentNumber(equipmentNumber, maintenanceRepairModeCode).subscribe((result) => {
      if (result.warnings.length > 0) {
        let filteredWarning = result.warnings.filter(
          (warning: { rulesetName: string; code: string }) => warning.rulesetName === 'equipment_past_repair_ruleset',
        );
        if (filteredWarning && filteredWarning.length > 0) {
          const pastRepairs = filteredWarning[0].metadata?.ExistingRepairCodes.split(',');
          this.sharedDataService.setPastRepairs(pastRepairs);
        }
      }
    });
  }

  onAuditLogClosed() {
    this.openAuditLog = false;
  }

  onNewAuditLogClosed() {
    this.openNewAuditLog = false;
  }

  onPrintClicked(): void {
    this.openPrintDialog = true;
  }

  onPrintConfirmed(includeRemarks: boolean): void {
    this.includeRemarksInPrint = includeRemarks;
    this.openPrintDialog = false;
    setTimeout(() => (globalThis as unknown as Window).print(), 150);
  }

  onAuditLogClicked() {
    if (this.workOrder?.createdAt) {
      const cutoffDate = new Date(utils.getCutoffDate());
      const workOrderCreatedDate = new Date(this.workOrder.createdAt);

      if (workOrderCreatedDate > cutoffDate) {
        this.openNewAuditLog = true;
        this.openAuditLog = false;
      } else {
        this.auditlogApiCallStatus = 'IN_PROGRESS';
        this.auditlogNewApiCallStatus = 'IN_PROGRESS';
        forkJoin({
          api1Response: this.getAuditLogsFromOldAPI(),
          api2Response: this.getAuditLogsFromNewAPI(),
        }).subscribe({
          next: ({ api1Response, api2Response }) => {
            this.auditLog = { ...api1Response };
            this.newAuditLogData = api2Response.body || [];
            this.auditlogApiCallStatus = 'COMPLETED_SUCCESFULLY';
            this.auditlogNewApiCallStatus = 'COMPLETED_SUCCESFULLY';
            this.openAuditLog = true;
            this.openNewAuditLog = false;
          },
          error: () => {
            // handle error
            this.auditlogApiCallStatus = 'FAILED';
            this.auditlogNewApiCallStatus = 'FAILED';
            this.toastrService.showToastr(this.appTextService.auditLogCannotBeFetched, 'error');
          },
        });
      }
    }
  }

  getAuditLogsFromOldAPI() {
    return this.workOrderService.getAuditLogs(this.id);
  }

  getAuditLogsFromNewAPI() {
    return this.workOrderService.getAuditLogsFromNewAPI(
      this.workOrder?.maintenanceOrderNumber as number,
      this.isSystemLog,
      this.currentPage,
      this.pageLimit,
    );
  }

  onEditClicked() {
    this.sharedDataService.setWorkOrder(this.workOrder);
    this.sharedDataService.setEquipment(this.equipment);
    this.router.navigate(['/workorders/edit', this.id]);
  }

  onDeleteClicked() {
    this.openDeleteWorkOrderConfirmation = true;
  }
  onDeleteWorkOrderConfirmed() {
    this.deleteApiCallStatus = 'IN_PROGRESS';
    if (this.workOrder?.maintenanceOrderStatusCode === 10) {
      this.workOrderService
        .deleteDraftWorkOrder(this.id)
        .pipe(
          catchError((err) => {
            this.deleteApiCallStatus = 'FAILED';
            this.toastrService.showToastr(err.error.errorMessage, 'error');
            this.openDeleteWorkOrderConfirmation = false;
            return EMPTY;
          }),
        )
        .subscribe((x) => {
          this.deleteApiCallStatus = 'COMPLETED_SUCCESFULLY';
          timer(2000).subscribe((x) => {
            this.router.navigate(['/']);
          });
        });
    } else {
      this.workOrderService
        .deleteWorkOrder(this.id)
        .pipe(
          catchError((err) => {
            this.deleteApiCallStatus = 'FAILED';
            this.toastrService.showToastr(err.error.errorMessage, 'error');
            this.openDeleteWorkOrderConfirmation = false;
            return EMPTY;
          }),
        )
        .subscribe((x) => {
          this.deleteApiCallStatus = 'COMPLETED_SUCCESFULLY';
          timer(2000).subscribe((x) => {
            this.router.navigate(['/']);
          });
        });
    }
  }
  get deleteConfirmationMessage(): string {
    if (this.workOrder?.maintenanceOrderStatusCode === 10) {
      return 'The draft workorder will be deleted permanently. Are you sure you want to delete?';
    }
    return 'The workorder will be deleted permanently. Are you sure you want to delete?';
  }
  onDeleteWorkOrderConfirmationClosed() {
    this.openDeleteWorkOrderConfirmation = false;
  }
  onBackClicked() {
    this.router.navigate(['/workorders']);
  }
  onMarkCompleteClicked() {
    let request = this.mapToMaintenanceOrderPartSerialNumberUpdateRequest(this.workOrder);
    this.markAsCompleteAPICallStatus = 'IN_PROGRESS';
    this.workOrderService
      .completeWorkOrder(this.id, request)
      .pipe(
        catchError(() => {
          this.markAsCompleteAPICallStatus = 'FAILED';
          this.toastrService.showToastr(this.appTextService.workOrderCannotBeCompleted, 'error');
          return EMPTY;
        }),
      )
      .subscribe(() => {
        this.markAsCompleteAPICallStatus = 'COMPLETED_SUCCESFULLY';
        this.toastrService.showToastr(this.appTextService.workOrderMarkedComplete, 'success');
        this.workOrderStatus.set(utils.getMaintenanceOrderStatusText(MaintenanceOrderStatusCode.RepairCompleted).description);
        this.router.navigate(['/workorders']);
      });
  }
  mapToMaintenanceOrderPartSerialNumberUpdateRequest(
    workOrder: MaintenanceOrderResponse | null,
  ): MaintenanceOrderPartSerialNumberUpdateRequest | undefined {
    if (workOrder == null) {
      return undefined;
    }

    const partSerialNumbers: MaintenanceOrderPartSerialNumbers[] = [];

    workOrder.maintenanceOrderLines.forEach((lineItem) => {
      lineItem.maintenanceOrderParts.forEach((part) => {
        if (part.newSerialNumbers && part.newSerialNumbers.length > 0) {
          partSerialNumbers.push({
            maintenanceTypeCode: lineItem.maintenanceTypeCode,
            maintenanceRepairLocationCode: lineItem.maintenanceRepairLocationCode,
            partNumber: part.partNumber,
            newSerialNumbers: part.newSerialNumbers,
          });
        }
      });
    });

    if (partSerialNumbers.length === 0) {
      return undefined;
    }

    let serialNumberUpdateRequest: MaintenanceOrderPartSerialNumberUpdateRequest = {
      maintenanceOrderPartSerialNumbers: partSerialNumbers,
    };

    return serialNumberUpdateRequest;
  }

  onMarkAsTTLConfirmationClosed() {
    this.openMarkAsTTLConfirmation = false;
  }
  onMarkAsTTLConfirmationCancel() {
    this.openMarkAsTTLConfirmation = false;
  }
  onMarkAsTTLConfirmationDone() {
    this.openMarkAsTTLConfirmation = false;
    this.markAsTtlApiCallStatus = 'IN_PROGRESS';
    this.workOrderService
      .markAsTTl(this.id)
      .pipe(
        catchError(() => {
          this.markAsTtlApiCallStatus = 'FAILED';
          this.toastrService.showToastr(this.appTextService.errorWHileMarkingAsTTL, 'error');
          return EMPTY;
        }),
      )
      .subscribe(() => {
        this.markAsTtlApiCallStatus = 'COMPLETED_SUCCESFULLY';
        this.toastrService.showToastr(this.appTextService.workOrderMarkedAsTTL, 'success');
        this.workOrderStatus.set(utils.getMaintenanceOrderStatusText(MaintenanceOrderStatusCode.DeclaredAsTTL).description);
        this.router.navigate(['/workorders']);
      });
  }
  onRejectClicked() {
    this.rejectAsTtlApiCallStatus = 'IN_PROGRESS';
    this.workOrderService
      .rejectAsTTL(this.id)
      .pipe(
        catchError(() => {
          this.rejectAsTtlApiCallStatus = 'FAILED';
          this.toastrService.showToastr(this.appTextService.errorWhileRejecting, 'error');
          return EMPTY;
        }),
      )
      .subscribe(() => {
        this.rejectAsTtlApiCallStatus = 'COMPLETED_SUCCESFULLY';
        this.toastrService.showToastr(this.appTextService.workOrderRejected, 'success');
        this.router.navigate(['/workorders']);
      });
  }
  onMarkTTLClicked() {
    this.openMarkAsTTLConfirmation = true;
  }

  getGensetHours(flag: boolean = true) {
    if (flag && this.equipment?.equipmentTypeParentCode === 'GENS') {
      this.workOrderService
        .getGensetHours(this.id)
        .pipe(
          takeUntil(this.destroyed$),
          catchError(() => {
            this.toastrService.showToastr(this.appTextService.unableToGetGensetHours, 'error');
            return EMPTY;
          }),
        )
        .subscribe((response) => {
          this.gensetHours = response;
        });
    }
  }
  private async getBlobUrl(shopCode: string | undefined, attachedImages: AttachedImage[]): Promise<AemsFile[]> {
    let temp: AemsFile[] = [];
    if (attachedImages.length > 0) {
      for (let i = 0; i < attachedImages.length; i++) {
        if (!attachedImages[i].storageUrl) {
          let url = await firstValueFrom(
            this.blobService.getResourceUrl(shopCode, attachedImages[i].path ?? '').pipe(takeUntil(this.destroyed$)),
          );
          temp.push({
            fileUrl: url,
            shopCode: shopCode,
            uploadedToBlob: true,
            generatedName: attachedImages[i].path ?? '',
            fileType: utils.fileType(attachedImages[i].path ?? ''),
            displayName: attachedImages[i].name,
            isDownloadDisabled: false,
          });
        } else {
          temp.push({
            fileUrl: attachedImages[i].storageUrl ?? '',
            shopCode: shopCode,
            uploadedToBlob: true,
            generatedName: attachedImages[i].path ?? '',
            fileType: utils.fileType(attachedImages[i].path ?? ''),
            displayName: attachedImages[i].name,
            isDownloadDisabled: false,
            storageUrl: attachedImages[i].storageUrl,
            storageSource: attachedImages[i].storageSource,
          });
        }
      }
    }
    return temp;
  }
  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  get canShowDeleteButton(): boolean {
    const status = this.workOrder?.maintenanceOrderStatusCode;
    return status !== null && status !== undefined && this.allowedStatusToDelete.includes(status) && this.authPolicy.canDeleteWorkOrder;
  }
}
